export const setNav = () => {
  return {
    type: "SET_NAVBAR",
  };
};

export const setLogIn = () => {
  return {
    type: "SIGN_IN",
  };
};

export const setLoggedInUser = () => {
  return {
    type: "LOGGED_IN_USER",
  };
};

export const logOutUser = () => {
  return {
    type: "LOG_OUT_USER",
  };
};
